import { Breadcrumb, Button, Table } from "antd";
import { ExportOutlined, HomeOutlined } from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import { Excel } from "antd-table-saveas-excel";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { _adr } from "../../../../address";
import { useDealer } from "../../../../tools/api";
import { NotFound } from "../../../../sources/svg/svg";
import Loading from "../../../auxiliary/loader/loading";
import styles from "./assignedKitList.module.scss";

const columns = [
	{ title: "شماره کیت", dataIndex: "kitNo", key: "kitNo", width: 150 },
	{ title: "نوع مخزن", dataIndex: "poolType", key: "poolType", width: 180 },
	{ title: "وضعیت", dataIndex: "requestStatus", key: "requestStatus", width: 150 },
];

const AssignedKitList = () => {
	const location = useLocation();
	const nav = useNavigate();
	const { queryKitAssignedToUser } = useDealer();
	const requestId = location?.state?.requestId;

	const [kits, setKits] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		const loadKits = async () => {
			if (!requestId) return;
			setIsLoading(true);
			try {
				const response = (await queryKitAssignedToUser({ iccidRequestId: requestId })) || [];
				setKits(response);
			} catch (error) {
				console.error("Failed to load kit list:", error);
			}
			setIsLoading(false);
		};
		loadKits();
	}, [requestId]);

	const dataSource = kits.map((item, key) => ({
		key,
		kitNo: item.kitNo,
		poolType: item.poolType,
		requestStatus: item.requestStatus,
	}));

	const handleExport = () => {
		const excel = new Excel();
		excel.addSheet("لیست کیت").addColumns(columns).addDataSource(dataSource, { str2Percent: true }).saveAs("assigned-kit-list.xlsx");
	};

	return (
		<div className="container-main container-cw">
			<div className="holder-top-of-page-content">
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[
							{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> },
							{ href: _adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.NewRequest, title: "مدیریت کیت سیم‌کارت" },
							{ href: _adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.AssignKit, title: "تخصیص کیت به نماینده" },
							{ title: "لیست کیت" },
						]}
					/>
					<div className="title-page">
						<h3>لیست کیت</h3>
						<p></p>
					</div>
				</div>
			</div>
			<div className="g-layout-content">
				<Content className="g-layout-main da-container">
					<div className="g-format-page">
						<div className={`g-body-format-page ${styles.container}`}>
							<div className="holder-table">
								<div className="holder-top-table">
									<div className="holder-button">
										<Button onClick={handleExport} icon={<ExportOutlined />} className="btn-normal btn-print">
											خروجی اکسل
										</Button>
									</div>
								</div>
								<Table
									className="tbl-normal"
									columns={columns}
									locale={{ emptyText: <NotFound text={"رکوردی یافت نشد."} /> }}
									pagination={false}
									dataSource={dataSource}
								/>
							</div>

							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button
										className="btn-normal"
										type="default"
										onClick={() => nav(_adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.AssignKit)}>
										بازگشت
									</Button>
								</div>
							</div>
						</div>
					</div>
				</Content>
			</div>
			<Loading isOpen={isLoading} />
		</div>
	);
};

export default AssignedKitList;
